import React from 'react';

import artwork from '../../../../Assets/Linkages/SpaceOutreachFilm/World-TV-Premiere.png';

const WorldTelevisionPremiere = () => (
  <section
    className="outreach-film-feature outreach-film-feature--grey"
    aria-labelledby="world-television-premiere-title"
  >
    <div className="outreach-film-feature-inner outreach-film-feature-inner--reverse">
      <div className="outreach-film-feature-copy">
        <p className="section-eyebrow">NATIONWIDE ON WORLD ENVIRONMENT DAY</p>
        <h2 id="world-television-premiere-title">World Television Premiere</h2>
        <div className="world-space-week-title-line" aria-hidden="true" />
        <p>
          The World TV Premiere of Jahan Aur Bhi Hain — Beyond the Blue aired nationwide on PTV
          Home on June 5, 2025, in observance of World Environment Day.
        </p>
        <p>
          Reaching audiences across Pakistan, the telefilm continues its journey through university
          screenings, film festivals, and public outreach events, amplifying its core message of
          climate awareness and space science for a sustainable future.
        </p>
      </div>

      <figure className="outreach-film-feature-artwork">
        <img src={artwork} alt="World Television Premiere of Jahan Aur Bhi Hain" loading="lazy" />
      </figure>
    </div>
  </section>
);

export default WorldTelevisionPremiere;
